import {
  Component,
  Input,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
export class YztTabBodyComponent {
   content: TemplateRef<void>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector     : 'yzt-tab-body',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'content': [{ type: Input },],
};
}

function YztTabBodyComponent_tsickle_Closure_declarations() {
/** @type {?} */
YztTabBodyComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YztTabBodyComponent.ctorParameters;
/** @type {?} */
YztTabBodyComponent.propDecorators;
/** @type {?} */
YztTabBodyComponent.prototype.content;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
